import Login from "./components/Login"
import RegisterUser from "./components/RegisterUser"
import RegisterCompany from "./components/RegisterCompany"
import Forgot from "./components/ForgotPassword"
import ForgotResetPassword from "./components/ForgotResetPassword"
import ForceChangePassword from "./components/ForceChangePassword"
import FeideAuthCallback from "./components/FeideAuthCallback"

let module = "auth"

export default [
  {
    path: "forgot",
    component: Forgot,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
  {
    path: "forgot/resetpassword/:token",
    component: ForgotResetPassword,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },

  {
    path: "login",
    component: Login,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
  {
    path: "register/user",
    component: RegisterUser,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
  {
    path: "register/company",
    component: RegisterCompany,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
  {
    path: "forcechangepassword",
    component: ForceChangePassword,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },

  {
    path: "feide/callback",
    component: FeideAuthCallback,
    props: true,
    meta: { module: module, permissions: ["all"] },
  },
]
